<template>
    <div id="app">
        <router-view class="router-view-c main-view" style=""/>
    </div>
</template>

<script>
    export default {
        name: 'App'
    }
</script>

<style>

    html, body {
        margin: 0;
        padding: 0;
        background-color: white;
    }

    /*
    ##Device = Desktops
    ##Screen = 1281px to higher resolution desktops
    */

    @media (min-width: 1281px) {

    }

    /*
    ##Device = Laptops, Desktops
    ##Screen = B/w 1025px to 1280px
    */

    @media (min-width: 1025px) and (max-width: 1280px) {

    }

    /*
    ##Device = Tablets, Ipads (portrait),
    ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) {
        html {
            font-size: 20px;
        }
    }

    /*
    ##Device - ipad pro
    */
    @media (width: 1024px) {
        html {
            font-size: 40px;
        }
    }

    /*
    ##Device = Tablets, Ipads (landscape)
    ##Screen = B/w 768px to 1024px
    */

    @media (min-width: 768px) and (max-width: 1024px) and (orientation: landscape) {

    }

    /*
    ##Device = Low Resolution Tablets, Mobiles (Landscape)
    ##Screen = B/w 481px to 767px
    */

    @media (min-width: 481px) and (max-width: 767px) {

    }

    /*
    ##Device = Most of the Smartphones Mobiles (Portrait)
    ##Screen = B/w 320px to 479px
    */

    @media (min-width: 320px) and (max-width: 480px) {
        html {
            font-size: 10px;
        }
    }

    #app {
        font-family: 'Noto Sans KR', sans-serif;
        -webkit-font-smoothing: antialiased;
        -moz-osx-font-smoothing: grayscale;
        text-align: center;
        color: #2c3e50;
    }
</style>
